import ClientesView from "../views/clientes/ClientesView";
import DadosClienteView from "../views/clientes/DadosClienteView";
import CadProViewMobile from "../views/clientes/CadProViewMobile.vue";

export default [
  {
    path: "/clientes",
    name: "clientes",
    component: ClientesView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false
    },
  },
  {
    path: "/clientes/:id",
    name: "dados-cliente",
    component: DadosClienteView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: true
    },
  },
  {
    path: "/cadpros/:id/:nome",
    name: "dados-cadpro",
    component: CadProViewMobile,
    meta: {
      requiresAuth: true,
      device: [1],
      sync: true,
      online: true,
    },
  },
];
